var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "send-sms-postacell" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("SendSmsInputV2", {
        attrs: { "default-phone-number": _vm.phoneNumber },
        on: { sendSMS: _vm.sendSMS },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Send Sms")]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v("Send sms to your customers"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }